// libraries
import { Slider } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import MyPagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import "swiper/css";
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { NumeroFormatado } from '../../../utils/FunctionsGlobals';
// utils
import styles from './simulador.module.css';

// interfaces
interface INetworkPieces {
    site: any;
    setFullScram?: any;
    flutua: number;
    valorImovel?: number;
    origin?: any;
}

const Simulador: React.FC<INetworkPieces> = ({ site, setFullScram, flutua, valorImovel, origin }) => {
    // constants
    const router = useRouter();
    const { valor } = router.query;
    const { parcelas } = router.query;
    const { juros } = router.query;
    const { entrada } = router.query;
    const { opcao } = router.query;

    // states
    const [allValor, setAllValor] = useState<any>(valorImovel || 150000);
    const [allParcelas, setAllParcelas] = useState<any>(420);
    const [parcelasP, setParcelasP] = useState<Array<{numeroParcela: any, valorParcela: any, jurosPagos: any, amortizacao: any, saldoDevedor: any}>>([]);
    const [allJuros, setAllJuros] = useState<any>(site?.id == 2240 || site?.id == 1818 ? 12 : allValor <= 300000 ? 4 : 8);
    const [tipo, setTipo] = useState<any>("Price");
    const [page, setPage] = useState<number>(0);
    const [allEntrada, setAllEntrada] = useState<any>(site?.id == 1694 || site?.id == 1868 ? 30 : 20);
    const [swiper, setSwiper] = useState<any>(null);
    // const [jurosMes, setJurosMes] = useState<any>(0);
    // const data = [
    //     ["Valor", "Mensalidade"],
    //     ["Valor", (allValor-allEntrada)/allParcelas],
    //     ["Juros", jurosMes],
    //     ["Taxa Fixa - Banco", 25],
    //     ["Taxa de Seguro", 65]
    //   ];

    //  const options = {
    //     pieHole: 0,
    //     is3D: false,
    //     legend: "none",
    //     pieSliceText: "label",
    //     backgroundColor: "none",
    //     colors: ['#a39807','#0b2e59','#f5634a','#ed303c']
    //   }

    const handleShare = async () => {
        const shareData = {
            title: "Simulação de Financiamento",
            text: `Financiamento no valor de R$ ${allValor}, com entrada de ${allEntrada}, parcelado em ${allParcelas} vezes`,
            url: `https://${origin}?valor=${allValor}&entrada=${allEntrada}&opcao=${tipo}&parcelas=${allParcelas}&juros=${allJuros}&simulador=1`, // Você pode personalizar a URL
        };

        if (navigator.share) {
            try {
                await navigator.share(shareData);
                console.log("Compartilhado com sucesso!");
            } catch (err) {
                console.error("Erro ao compartilhar:", err);
            }
        } else {
            // Fallback para navegadores que não suportam a Web Share API
            alert("Compartilhamento não suportado neste navegador. URL copiada para a área de transferência!");
            navigator.clipboard.writeText(shareData.url);
        }
    };

    const selectValor = (
      newValue: any,
    ) => {
      setAllValor(Number(newValue?.target?.value))
    };

    const selectParcelas = (
      newValue: any,
    ) => {
      setAllParcelas(Number(newValue?.target?.value))
    };

    const selectJuros = (
      newValue: any,
    ) => {
      setAllJuros(Number(newValue?.target?.value))
    };

    const selectEntrada = (
      newValue: any,
    ) => {
      setAllEntrada(Number(newValue?.target?.value))
    };

    const handleChange = (event: any, newPage: any) => {
        // Quando a página de paginação muda, atualize o estado da página
        setPage(newPage - 1); // Lembre-se de que o estado da página começa em 0 no Swiper
        if (swiper) {
          swiper.slideTo(newPage - 1);
        }
    };

    // methods
    useEffect(() => {
        if(tipo == "SAC"){
            const taxaJurosMensal = (1 + (allJuros / 100)) ** (1 / 12) - 1;
            const valorFinanciado = allValor - (allValor * (allEntrada / 100));
            const amortizacao = valorFinanciado / allParcelas;

            const parcelas = [];
            let saldoDevedor = valorFinanciado;

            for (let i = 1; i <= allParcelas; i++) {
                const jurosPagos = saldoDevedor * taxaJurosMensal;
                const valorParcela = amortizacao + jurosPagos;
                saldoDevedor -= amortizacao;
                parcelas.push({
                    numeroParcela: i,
                    valorParcela: valorParcela.toFixed(2),
                    jurosPagos: jurosPagos.toFixed(2),
                    amortizacao: amortizacao.toFixed(2),
                    saldoDevedor: saldoDevedor.toFixed(2),
                });
            }

            setParcelasP(parcelas)
        } else {
            const taxaJurosMensal = (1 + (allJuros / 100)) ** (1 / 12) - 1;
            const valorFinanciado = allValor - (allValor * (allEntrada / 100));

            const parcela = (valorFinanciado * (taxaJurosMensal * (1 + taxaJurosMensal) ** allParcelas)) / ((1 + taxaJurosMensal) ** allParcelas - 1);

            const parcelas = [];
            let saldoDevedor = valorFinanciado;

            for (let i = 1; i <= allParcelas; i++) {
                const jurosPagos = saldoDevedor * taxaJurosMensal;
                const amortizacao = parcela - jurosPagos;
                saldoDevedor -= amortizacao;
                parcelas.push({
                    numeroParcela: i,
                    valorParcela: parcela.toFixed(2),
                    jurosPagos: jurosPagos.toFixed(2),
                    amortizacao: amortizacao.toFixed(2),
                    saldoDevedor: saldoDevedor.toFixed(2),
                });
            }

            setParcelasP(parcelas)
        }

        if(allParcelas!=420 || allJuros!=4 || allEntrada!=20 || tipo != 'Price'){
            localStorage.setItem('allValor', allValor);
            localStorage.setItem('allParcelas', allParcelas);
            localStorage.setItem('allJuros', allJuros);
            localStorage.setItem('allEntrada', allEntrada);
            localStorage.setItem('tipo', tipo);
        }
    }, [allValor,allParcelas,allJuros,allEntrada,tipo]);

    useEffect(() => {
        if(valor || parcelas || juros || entrada || opcao) {
            setAllValor(valor)
            setAllParcelas(parcelas)
            setAllJuros(juros)
            setAllEntrada(entrada)
            setTipo(opcao == 'SAC' ? 'SAC' : 'Price')
        }
    }, [valor,parcelas,juros,entrada,opcao]);

    useEffect(() => {
        if(valorImovel) {
            setAllValor(valorImovel)
        }
    }, [valorImovel]);

    useEffect(() => {
        if(valorImovel==undefined && valor==undefined && flutua){
            setAllValor(localStorage.getItem('allValor') || 150000);
        }
        if(!parcelas){
            setAllParcelas(localStorage.getItem('allParcelas') || 420);
        }
        if(!entrada){
            setAllEntrada(localStorage.getItem('allEntrada') || 20);
        }
        if(!juros){
            setAllJuros(localStorage.getItem('allJuros') || 4);
        }
        if(!opcao){
            setTipo(localStorage.getItem('tipo') || 'Price');
        }
    }, [entrada, flutua, juros, parcelas, valor, valorImovel, opcao])

    return (
        <div id="Simulador" className={flutua ? styles.container : styles.container1}>
            <div className={flutua ? styles.container2 : styles.container2off} onClick={() => setFullScram(0)}/>
            <div className={flutua ? styles.adjust_closed_modal : styles.container2off}>
                <div
                    className={styles.closed_modal}
                    onClick={() => setFullScram(0)}
                >
                    <IoCloseSharp size={36} color="#d24444" />
                </div>
            </div>
            <div className={ flutua ? styles.adjust_img : styles.adjust_img2} >
            <p className={styles.title_caracters} style={!flutua && site?.modelo_pagina_imovel == 3 ? {width: "95%",margin: "0px 2.5%"} : {}}>
                <b>SIMULAR FINANCIAMENTO</b>
            </p>
            <p className={styles.title_caracters1} style={!flutua && site?.modelo_pagina_imovel == 3 ? {marginBottom: '0px',width: "95%",margin: "0px 2.5%"} : {marginBottom: '0px'}}>
                Simule o financiamento <b>{tipo}</b> do seu imóvel e saiba o valor dos juros, taxas e amortização mensal.
            </p>
            {
                site?.id != '1812' ?
                    <p className={styles.title_caracters1} style={!flutua && site?.modelo_pagina_imovel == 3 ? {color: 'red',width: "95%",margin: "0px 2.5% 20px 2.5%"} : {color: 'red'}}>
                        Entrada: Você pode usar: FGTS; Parcelamento direto com a construtora (mediante acordo prévio); ou recursos próprios.
                    </p>
                :
                    <p className={styles.title_caracters1} style={!flutua && site?.modelo_pagina_imovel == 3 ? {color: 'red',width: "95%",margin: "0px 2.5% 20px 2.5%"} : {color: 'red'}}>
                        Entrada: Você pode usar: Parcelamento direto com a construtora (pós e/ou pré chave); ou recursos próprios.
                    </p>
            }

            <div className={styles.duo}>
            <ButtonGroup
                disableElevation
                variant="contained"
                aria-label="Disabled elevation buttons"
            >
                <Button
                onClick={() => setTipo("SAC")}
                className={tipo === "SAC" ? styles.tipoSelected : styles.tipo}
                style={
                    tipo === "SAC"
                    ? site?.id === 2331
                        ? { background: "#2B394E" }
                        : site?.id === 2231
                        ? { background: "#969696" }
                        : site?.cor2 === "#ffffff"
                        ? { background: "#a39807" }
                        : { background: site?.cor2 }
                    : {}
                }
                >
                SAC
                </Button>
                <Button
                onClick={() => setTipo("Price")}
                className={tipo === "Price" ? styles.tipoSelected : styles.tipo}
                style={
                    tipo === "Price"
                    ? site?.id === 2331
                        ? { background: "#2B394E" }
                        : site?.id === 2231
                        ? { background: "#969696" }
                        : site?.cor2 === "#ffffff"
                        ? { background: "#a39807" }
                        : { background: site?.cor2 }
                    : {}
                }
                >
                Price
                </Button>
            </ButtonGroup>
            </div>

            <div className={styles.divid} style={!flutua && site?.modelo_pagina_imovel == 3 ? {width: "95%",margin: "0px 2.5%"} : {}}>
                <div className={styles.duo}>
                    <div className={styles.text_inline}>
                        <h5 className={styles.subtitle}>Valor do imóvel:</h5>
                        <h5 className={styles.valor}>{site?.moeda_tipo} {NumeroFormatado(allValor)}</h5>
                    </div>
                    <Slider
                        valueLabelDisplay="auto"
                        value={Number(allValor)}
                        onChange={selectValor}
                        min={50000}
                        max={2500000}
                        step={10000}
                        style={{
                            color: site?.id == 2331 ? '#2B394E' : site?.id === 2231 ? '#969696' : (site?.cor2 !== '#ffffff' ? site?.cor2 : '#a39807'),
                            height: '10px'
                        }}
                    />
                    <div className={styles.text_inline2}>
                        <h5 className={styles.subtitle}>Parcelas:</h5>
                        <h5 className={styles.valor}>{allParcelas/12}</h5>
                        <h5 className={styles.subtitle}>anos</h5>
                    </div>
                    <Slider
                        valueLabelDisplay="auto"
                        value={Number(allParcelas)}
                        onChange={selectParcelas}
                        min={48}
                        max={480}
                        step={6}
                        style={{
                            color: site?.id == 2331 ? '#2B394E' : site?.id === 2231 ? '#969696' : (site?.cor2 !== '#ffffff' ? site?.cor2 : '#a39807'),
                            height: '10px'
                        }}
                    />

                    <div className={styles.duo2}>
                        <div className={styles.text_inline0}>
                            <div className={styles.text_inline}>
                                <h5 className={styles.subtitle}>Entrada:</h5>
                                <h5 className={styles.valor}>{allEntrada}%</h5>
                                <h5 className={styles.subtitle}>({site?.moeda_tipo} {NumeroFormatado(allValor*(allEntrada/100))})</h5>
                            </div>
                            <Slider
                                valueLabelDisplay="auto"
                                value={Number(allEntrada)}
                                onChange={selectEntrada}
                                min={site?.id == 1694 ? 30 : 10}
                                max={90}
                                step={1}
                                style={{
                                    color: site?.id == 2331 ? '#2B394E' : site?.id === 2231 ? '#969696' : (site?.cor2 !== '#ffffff' ? site?.cor2 : '#a39807'),
                                    height: '10px'
                                }}
                            />
                        </div>
                        <div className={styles.text_inline1}>
                            <div className={styles.text_inline2}>
                                <h5 className={styles.subtitle}>Juros:</h5>
                                <h5 className={styles.valor}>{allJuros}%</h5>
                                <h5 className={styles.subtitle}>ao ano</h5>
                            </div>
                            <Slider
                                valueLabelDisplay="auto"
                                value={Number(allJuros)}
                                onChange={selectJuros}
                                min={2}
                                max={15}
                                step={0.5}
                                style={{
                                    color: site?.id == 2331 ? '#2B394E' : site?.id === 2231 ? '#969696' : (site?.cor2 !== '#ffffff' ? site?.cor2 : '#a39807'),
                                    height: '10px'
                                }}
                            />
                        </div>
                    </div>

                    <div className={styles.duo3}>

                        { origin && site?.id != 2208 ?
                            <div className={styles.text_inline3}>
                                <div className={styles.text_inline2}>
                                    <button className={styles.button1} onClick={handleShare}>Compartilhar</button>
                                </div>
                            </div>
                        : null}
                        <div className={styles.text_inline3}>
                            <Link prefetch={false} href={`/imoveis/venda/-/-/-/-?min=${allValor*0.8}&max=${allValor*1.2}`} passHref>
                                <div
                                    title={`Buscar imóveis entre R$ ${allValor*0.8} e ${allValor*1.2}`}
                                    className={`${styles.text_inline2} ${styles.button1}`} // Adiciona o estilo do botão no link
                                >
                                    Buscar imóveis
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className={styles.duoPrice} style={{padding: "40px 0px"}}>
                            {/* <h3 className={styles.subtitulo}>Valor da 1ª parcela: </h3>
                            <h3 className={styles.resultado}>{site?.moeda_tipo} {NumeroFormatado(Number(mensalidade))} / mês</h3>
                            <h4 className={styles.subtitulo}>Valor da última parcela: </h4>
                            <h4 className={styles.resultado} style={{color: '#a39807'}}>{site?.moeda_tipo} {NumeroFormatado(Number((allValor-allEntrada)/allParcelas))} / mês</h4> */}
                            {/* <h4 className={styles.subtitulo} style={{color: '#0b2e59'}}>Valor dos Juros: {site?.moeda_tipo} {NumeroFormatado(jurosMes)} </h4>
                            <h4 className={styles.subtitulo} style={{color: '#ed303c'}}>Outras taxas (banco): {site?.moeda_tipo} 90,00</h4> */}
                            {/* <Chart
                                chartType="PieChart"
                                width="100%"
                                height="350px"
                                className={styles.chart}
                                data={data}
                                options={options}
                                />                     */}
                    {parcelasP?.length > 0 ?
                    <>
                        <Swiper
                            onSwiper={(s: any) => setSwiper(s)}
                            className={styles.swiper}
                            slidesPerView={1}
                            spaceBetween={10}
                            initialSlide={page}
                            pagination={{
                                clickable: true,
                            }}
                            onSlideChange={(swiper: any) => {
                                setPage(swiper.activeIndex);
                            }}
                        >
                            {parcelasP.map((parcela, cont) => {
                                return (
                                <SwiperSlide key={cont}>
                                    <div>
                                        <h3 className={styles.subtitulo}>Valor da {parcela?.numeroParcela}ª parcela: </h3>
                                        <h3 className={styles.resultado}>{site?.moeda_tipo} {NumeroFormatado(Number(parcela?.valorParcela))} / mês</h3>
                                        {
                                            site?.id != '2003' ? <h5 className={styles.subtitulo}>Valor da amortização: </h5> : null
                                        }
                                        <h4 className={styles.resultado} style={{color: site?.id == 2331 ? '#2B394E' : site?.id === 2231 ? '#969696' : (site?.cor2 === '#ffffff' ? '#a39807' : site?.cor2)}}>{site?.moeda_tipo} {NumeroFormatado(Number(parcela?.amortizacao))} / mês</h4>
                                        <h4 className={styles.subtitulo}>Valor Última Parcela: </h4>
                                        <h4 className={styles.resultado} style={{color: site?.id == 2331 ? '#2B394E' : site?.id === 2231 ? '#969696' : (site?.cor2 === '#ffffff' ? '#a39807' : site?.cor2)}}>{site?.moeda_tipo} {NumeroFormatado(Number(parcelasP[parcelasP?.length-1]?.valorParcela))}</h4>
                                    </div>
                                </SwiperSlide>
                                );
                            })}
                        </Swiper>
                        <Stack spacing={2} className={styles.pagination}>
                            <MyPagination
                                count={parcelasP?.length}
                                page={page+1}
                                onChange={(event, newPage) => handleChange(event, newPage)}
                            />
                        </Stack>
                    </>
                    : null}
                </div>
                </div>
            </div>
        </div>

    );
};

export default Simulador;
